import React, { useState, useEffect } from "react";
import DashboardFooter from "../components/DashboardFooter";
import { Quantum } from "ldrs/react";
import { NotificationManager } from "react-notifications";

const Payment = () => {
  const [activeTab, setActiveTab] = useState("links");
  const [transactions, setTransactions] = useState([]);
  const [paymentLinks, setPaymentLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedTxId, setExpandedTxId] = useState(null);
  const [copiedId, setCopiedId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    amount: "",
    notes: "",
  });
  const [creating, setCreating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);



  const handleCopy = async (key, id) => {
    try {
      const redirectUrl = `${window.location.origin}/#/payment-link/${key}`;
      await navigator.clipboard.writeText(redirectUrl);
      setCopiedId(id);
      NotificationManager.success("Payment link copied to clipboard!", "Copied", 2000);

      setTimeout(() => setCopiedId(null), 1500);
    } catch (err) {
      console.error("Failed to copy:", err);
      NotificationManager.error("Failed to copy link", "Error", 2000);
    }
  };

  // 🧾 Fetch payment links when tab changes
  useEffect(() => {
    if (activeTab === "links") {
      const fetchLinks = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
          const response = await fetch(
            `${process.env.REACT_APP_HOST_API_URL}/admin-user/payment-link/`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const data = await response.json();
          console.log("Payment Links:", data);
          setPaymentLinks(data.data || []);
        } catch (err) {
          console.error("Error fetching payment links:", err.message);
          NotificationManager.error("Failed to fetch payment links", "Error", 3000);
        } finally {
          setLoading(false);
        }
      };
      fetchLinks();
    }
  }, [activeTab, refreshKey]);

  // 🧾 Fetch transactions when tab changes
  useEffect(() => {
    if (activeTab === "transactions") {
      const fetchTransactions = async () => {
        setLoading(true);
        const token = localStorage.getItem("token");
        try {
          const response = await fetch(
            `${process.env.REACT_APP_HOST_API_URL}/admin-user/transactions-by-link/`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const data = await response.json();
          console.log("Transactions:", data);
          setTransactions(data.data || []);
        } catch (err) {
          console.error(err.message);
          NotificationManager.error("Failed to fetch transactions", "Error", 3000);
        } finally {
          setLoading(false);
        }
      };
      fetchTransactions();
    }
  }, [activeTab]);


  const toggleExpand = (id) => {
    setExpandedTxId(expandedTxId === id ? null : id);
  };

  // Create new payment link with notifications
  const handleCreateLink = async (e) => {
    e.preventDefault();
    setCreating(true);

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOST_API_URL}/admin-user/payment-link/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ data: formData }),
        }
      );

      if (!response.ok) {
        NotificationManager.error("Failed to create payment link", "Error", 3000);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      NotificationManager.success("Payment link created successfully", "Success", 3000);

      setFormData({ name: "", email: "", mobile: "", amount: "", notes: "" });
      console.log("Created Payment Link:", data);

      if (activeTab === "links") {
        setPaymentLinks((prev) => [data.data, ...prev]);
      }
      setRefreshKey(prev => prev + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100 pb-2 px-3">
      <div className="flex-grow-1">
        <div className="container-fluid px-2 px-md-4" style={{ paddingTop: "20px" }}>
          {/* Header */}
          <div
            className="appointment-header row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded"
            style={{
              background: "linear-gradient(135deg, #0564bf, #89CFF0)",
            }}
          >
            <div
              className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
              style={{ gap: "1rem" }}
            >
              <h3 className="text-light mb-1">Payments</h3>
            </div>
          </div>

          {/*  Create Payment Link Form */}
          <div className="bg-white p-4 rounded shadow-sm mb-4">
            <div className="px-3">
              <h5 className="mb-3 text-primary">Create Payment Link</h5>
              <form className='px-3' onSubmit={handleCreateLink}>
                <div className="row ">
                  <div className="col-md-6 mb-3 ">
                    <label className="form-label fw-semibold">Name</label>
                    <input
                      type="text"
                      className="form-control"

                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Email</label>
                    <input
                      type="email"
                      className="form-control"

                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Mobile</label>
                    <input
                      type="text"
                      className="form-control"

                      value={formData.mobile}
                      onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Amount</label>
                    <input
                      type="number"
                      className="form-control"

                      value={formData.amount}
                      onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Notes</label>
                  <textarea
                    className="form-control"
                    rows="3"

                    value={formData.notes}
                    onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                  ></textarea>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    type="submit"
                    className="btn btn-primary py-2 fw-semibold"
                    disabled={creating}
                  >
                    {creating ? (
                      <>
                        <Quantum size="20" speed="1.5" color="white" /> Creating...
                      </>
                    ) : (
                      "Create Link"
                    )}
                  </button>
                </div>

              </form>
            </div>
          </div>

          {/* NAV TABS BELOW FORM */}
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "links" ? "active" : ""}`}
                onClick={() => setActiveTab("links")}
              >
                Links
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "transactions" ? "active" : ""}`}
                onClick={() => setActiveTab("transactions")}
              >
                Transactions
              </button>
            </li>
          </ul>

          {/* Tab Content */}
          <div className="mt-4">

            {/* 💳 LINKS TAB */}
            {activeTab === "links" && (
              <>
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <Quantum size="45" speed="1.75" color="blue" />
                  </div>
                ) : paymentLinks.length === 0 ? (
                  <div className="text-center py-5 text-muted bg-white rounded shadow-sm">
                    No payment links found.
                  </div>
                ) : (
                  <div className="table-responsive shadow-sm rounded bg-white mt-3 mb-5">
                    <table className="table mb-0 align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Amount</th>
                          <th>Copy Link</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentLinks.map((link) =>
                          link ? (
                            <React.Fragment key={link.id}>
                              {/* clickable row */}
                              <tr
                                onClick={() => toggleExpand(link.id)}
                                style={{
                                  cursor: "pointer",
                                  transition: "background-color 0.3s ease",
                                }}
                                className={expandedTxId === link.id ? "table-active" : ""}
                              >
                                <td>
                                  {link.created_at
                                    ? new Intl.DateTimeFormat("en-GB", {
                                      day: "numeric",
                                      month: "short",
                                      year: "numeric",
                                    }).format(new Date(link.created_at))
                                    : "-"}
                                </td>
                                <td>{link.name || "-"}</td>
                                <td>{link.email || "-"}</td>
                                <td>
                                  <span className="fw-bold text-primary">
                                    ${link.amount ? Number(link.amount).toFixed(2) : "0.00"}
                                  </span>

                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleCopy(link.unique_key, link.id);
                                    }}
                                  >
                                    {copiedId === link.id ? "Copied!" : "Copy Link"}
                                  </button>

                                  <span
                                    style={{
                                      display: 'inline-block',
                                      transition: 'transform 0.3s',
                                      transform: expandedTxId === link.id ? 'rotate(90deg)' : 'rotate(0deg)',
                                      marginLeft: '20px'

                                    }}
                                  >
                                    <img
                                      src="https://img.icons8.com/?size=100&id=33619&format=png&color=228BE6"
                                      alt="expand"
                                      width="20"
                                      height="20"
                                    />
                                  </span>
                                </td>
                              </tr>

                              {/* ✨ Stylish expanded section */}
                              {expandedTxId === link.id && (
                                <tr>
                                  <td colSpan="5" className="p-0">
                                    <div
                                      className="p-3 mx-2 my-2 rounded shadow-sm"
                                      style={{
                                        background:
                                          "linear-gradient(135deg, #f8fbff, #e9f3ff)",
                                        borderLeft: "5px solid #0d6efd",
                                        animation: "fadeIn 0.4s ease-in-out",
                                      }}
                                    >
                                      <div className="d-flex align-items-start">
                                        <div
                                          className="me-3 d-flex justify-content-center align-items-center rounded-circle"
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                            backgroundColor: "#0d6efd20",
                                          }}
                                        >
                                          <i
                                            className="bi bi-chat-text text-primary fs-5"
                                            style={{ lineHeight: 1 }}
                                          ></i>
                                        </div>
                                        <div>
                                          <h6 className="fw-semibold text-primary mb-1">
                                            Notes
                                          </h6>
                                          <p
                                            className="text-muted mb-0"
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >
                                            {link.notes ? (
                                              link.notes
                                            ) : (
                                              <span className="fst-italic text-secondary">
                                                No notes provided.
                                              </span>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          ) : null
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}


            {/* 💰 TRANSACTIONS TAB */}
            {activeTab === "transactions" && (
              <>
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "200px" }}
                  >
                    <Quantum size="45" speed="1.75" color="blue" />
                  </div>
                ) : transactions.length === 0 ? (
                  <div className="text-center py-5 text-muted bg-white rounded shadow-sm">
                    No transactions found.
                  </div>
                ) : (
                  <div className="table-responsive shadow-sm rounded bg-white mt-3 mb-5">
                    <table className="table mb-0 align-middle">
                      <thead className="table-light">
                        <tr>
                          <th>Date</th>
                          <th>Name</th>
                          <th>Reference No</th>
                          <th>Status</th>
                          <th>Received Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactions.map((tx) => (
                          <React.Fragment key={tx.id}>
                            <tr onClick={() => toggleExpand(tx.id)} style={{ cursor: "pointer" }}>
                              <td>
                                {new Intl.DateTimeFormat("en-GB", {
                                  day: "numeric",
                                  month: "short",
                                  year: "numeric",
                                }).format(new Date(tx.created_at))}
                              </td>
                              <td>{tx.name}</td>
                              <td>{tx.reference_number}</td>
                              <td>
                                <span
                                  className={`badge ${tx.status === "failed"
                                    ? "text-danger"
                                    : tx.status === "pending"
                                      ? "text-warning"
                                      : "text-success"
                                    }`}
                                >
                                  {tx.status.toUpperCase()}
                                </span>
                              </td>
                              <td>
                                <span className="fw-bold text-primary">
                                  ${tx.amount ? Number(tx.amount).toFixed(2) : "0.00"}
                                </span>
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <DashboardFooter />
    </div>
  );
};

export default Payment;
